import api from "./api";

export type EmailConfig = {
  enabled: boolean;
  transport: 'smtp' | 'api';
  host?: string; port?: number; secure?: boolean;
  apiKey?: string; username?: string; password?: string;
  fromName?: string; fromEmail?: string;
};

export type SmsConfig = {
  enabled: boolean;
  provider: 'twilio' | 'other';
  accountSid?: string; authToken?: string; fromNumber?: string;
};

export type NotificationSettings = {
  email?: EmailConfig;
  sms?: SmsConfig;
  templates?: {
    ticketCreated?: { subject?: string; body?: string };
    ticketReady?: { subject?: string; body?: string };
    invoiceCreated?: { subject?: string; body?: string };
    invoicePaid?: { subject?: string; body?: string };
  };
};

export async function getNotificationSettings(token: string) {
  const res = await api.get('/notifications/settings', { headers: { Authorization: `Bearer ${token}` } });
  return res.data as NotificationSettings;
}

export async function updateNotificationSettings(token: string, payload: Partial<NotificationSettings>) {
  const res = await api.put('/notifications/settings', payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as NotificationSettings;
}

export async function testEmail(token: string, to: string, subject: string, body: string) {
  const res = await api.post('/notifications/test-email', { to, subject, body }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as { ok: boolean };
}

export async function testSms(token: string, to: string, message: string) {
  const res = await api.post('/notifications/test-sms', { to, message }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as { ok: boolean };
}

